// web/src/api/assist/summary-correction.ts —— AI 小结
// 拆自 web/src/api/assist.ts 的同名分区（内容原样搬运）；由 web/src/api/assist.ts 以 export * 聚合，导出面对调用方不变。
// 注：原「知识推荐反馈闭环」分区（建议卡反馈 / 建议统计 / 知识缺口清单与统计，共 6 个 wrapper）
// 指向的端点在问答知识库下线时一并删除，且全仓无消费者，故已整段移除。

import { get, post, type ReqConfig } from '../../request';
// ---------- AI 小结 ----------

export interface AISummaryDraft {
  found: boolean;
  category?: string;
  result?: string;
  note?: string;
  follow_up?: boolean;
  tags?: string;
  draft?: boolean;
  status?: string;
  summary?: string; // chat 场景
}

/** 读取 AI 小结草稿：GET /assist/summary/:refType/:refID
 *  调用方为短轮询（等 worker 生成），默认静默：失败不弹全局 toast；需要失败提示的调用方传 { silent: false }。 */
export function getAISummary(refType: 'call' | 'chat', refID: number, cfg?: ReqConfig): Promise<AISummaryDraft> {
  return get(`/assist/summary/${refType}/${refID}`, undefined, { silent: true, ...(cfg || {}) });
}

/** 手工重生成 AI 小结（异步，POST /assist/summary/generate） */
export function generateAISummary(refType: 'call' | 'chat', refID: number): Promise<{ accepted: boolean }> {
  return post('/assist/summary/generate', { ref_type: refType, ref_id: refID });
}
